module.exports = __webpack_public_path__ + "static/media/baccarat-vector.13a1a5b5.svg";